import {styled} from '@mui/material/styles';
import {forwardRef} from 'react';
import type {TypographyProps} from '../Typography';
import {Typography} from '../Typography';

export type AccordionTitleProps = Pick<TypographyProps, 'sx' | 'size' | 'fontWeight' | 'color' | 'variant' | 'component' | 'children'>;

const StyledTypography = styled(Typography)<AccordionTitleProps>(({theme}) => ({
    lineHeight: '2rem',
    [theme.breakpoints.down('sm')]: {
        width: '100%'
    }
}));

export const AccordionTitle = forwardRef<HTMLDivElement, AccordionTitleProps>(({
    children, ...props
}, ref) => (
    <StyledTypography
        className='MuiAccordionTitle-root'
        color='secondary'
        ref={ref}
        variant='h4'
        {...props}
    >{children}</StyledTypography>
));

AccordionTitle.displayName = 'AccordionTitle';
